module.exports = __webpack_public_path__ + "img/linkedin.5895b707.svg";